"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
const components_1 = require("./components");
const styles_1 = require("./styles");
const RotaCalendar = (_a) => {
    var { startDate = new Date(), endDate = null, dateFormat = "dd/MM/yyyy", disabled = false, isSelectsRange = false, minDate, maxDate, onChange, minYear = (0, moment_1.default)()
        .subtract(41, "years")
        .year(), maxYear = (0, moment_1.default)()
        .add(10, "years")
        .year() } = _a, props = __rest(_a, ["startDate", "endDate", "dateFormat", "disabled", "isSelectsRange", "minDate", "maxDate", "onChange", "minYear", "maxYear"]);
    const [inputValue, setInputValue] = (0, react_1.useState)(isSelectsRange ? null : startDate);
    const [startRangeDate, setStartRangeDate] = (0, react_1.useState)(startDate);
    const [endRangeDate, setEndRangeDate] = (0, react_1.useState)(endDate);
    const handleOnChange = (newDate) => {
        setInputValue(newDate);
        onChange && onChange({ date: newDate });
    };
    const handleRangeOnChange = (rangeDates) => {
        const [start, end] = rangeDates;
        setStartRangeDate(start);
        setEndRangeDate(end);
        onChange && onChange({ startDate: start, endDate: end });
    };
    const CustomHeaderWrapper = (props) => (react_1.default.createElement(components_1.CustomHeader, Object.assign({}, props, { minYear: minYear, maxYear: maxYear })));
    return (react_1.default.createElement(styles_1.StyledCalendar, Object.assign({}, props),
        react_1.default.createElement(react_datepicker_1.default, { disabled: disabled, customInput: react_1.default.createElement(components_1.CustomInput, { isSelectsRange: isSelectsRange, disabled: disabled, minYear: minYear, maxYear: maxYear }), selected: inputValue, onChange: isSelectsRange ? handleRangeOnChange : handleOnChange, dateFormat: dateFormat, renderCustomHeader: CustomHeaderWrapper, popperPlacement: "bottom", selectsRange: isSelectsRange, startDate: startRangeDate, endDate: endRangeDate, minDate: minDate, maxDate: maxDate })));
};
exports.default = RotaCalendar;
